const TermsOfServiceHeader = () => {
  return (
    <div className="relative w-full flex justify-between items-center px-[0.625rem]">
      <div className="h-[1.45rem]" />
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none">
        <div className="text-base leading-[0.625rem] font-semibold">
          Terms of Service
        </div>
      </div>
    </div>
  );
};

export default TermsOfServiceHeader;
